import { render } from "./TheFastPositionsContent.vue?vue&type=template&id=71fa3414"
import script from "./TheFastPositionsContent.vue?vue&type=script&lang=ts"
export * from "./TheFastPositionsContent.vue?vue&type=script&lang=ts"
script.render = render

export default script